var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinextra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2823 30.6842C34.701 30.6842 34.0965 29.7443 34.0965 28.8043V24.4989H33.0533V23.5995H34.1075V22.0439L35.7036 21.6311V23.5995H37.1781V24.4989H35.7036V28.7306C35.6979 28.8649 35.7214 28.9988 35.7725 29.1231C35.8236 29.2474 35.901 29.3592 35.9995 29.4506C36.098 29.5421 36.2151 29.6111 36.3429 29.6529C36.4706 29.6947 36.6059 29.7082 36.7394 29.6926C36.8876 29.6899 37.035 29.6689 37.1781 29.63V30.5405C36.891 30.6438 36.5872 30.6925 36.2823 30.6842Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61742 22.6854V25.4905H8.6511V26.4784H5.61742V30.5331H3.93286V21.6827H9.01234V22.6854H5.61742Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70502 30.5295V23.5996H11.3232V30.5295H9.70502Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9007 25.579V30.5294H18.5226V25.5532C18.5226 24.0345 17.2103 23.4189 15.2419 23.4189C14.2211 23.406 13.2062 23.5758 12.2451 23.9202V30.5294H13.8523V24.58C14.2708 24.4345 14.7104 24.3585 15.1535 24.3552C16.0787 24.3552 16.9007 24.6906 16.9007 25.579Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7746 27.599C20.9294 28.9739 21.7551 29.6669 23.1411 29.6669C23.8684 29.6787 24.5906 29.5433 25.2643 29.2688L25.6513 30.2088C24.8126 30.5593 23.9098 30.7301 23.001 30.7101C20.7009 30.7101 19.2191 29.4236 19.2191 27.0461C19.2191 24.757 20.5977 23.4189 22.6803 23.4189C24.763 23.4189 25.9315 24.6391 25.9315 26.9687L20.7746 27.599ZM22.6159 24.3184C21.5109 24.3192 20.6382 25.1302 20.6788 26.8507L24.3649 26.3752C24.3759 24.9495 23.6838 24.3191 22.6159 24.3184ZM22.6159 24.3184L22.6177 24.3184H22.614L22.6159 24.3184Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4594 27.8976L31.2103 30.5295H33.0718L30.3441 26.8434L32.8138 23.6033H31.2324L29.5995 25.955H29.5737L27.9923 23.6033H26.2304L28.6485 26.9208L25.9465 30.5332H27.6569L29.4336 27.8976H29.4594Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6883 24.58C40.3365 24.3527 41.0386 24.3283 41.701 24.51L42.0511 23.4557L41.9685 23.4502C41.7873 23.4378 41.5106 23.4189 41.2771 23.4189C40.1914 23.3706 39.1071 23.5411 38.0886 23.9202V30.5294H39.6883V24.58Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1583 30.7101C42.9467 30.7101 41.9072 29.8991 41.9072 28.5758C41.9072 26.7107 44.0267 26.2093 46.548 25.9955V25.6048C46.548 24.6538 45.8403 24.37 44.8118 24.37C44.1114 24.3772 43.4181 24.5121 42.766 24.7681L42.3974 23.9203C43.264 23.5905 44.1832 23.4206 45.1104 23.4189C46.7839 23.4189 48.0593 24.0493 48.0593 25.8223V30.2088C47.1363 30.5707 46.1493 30.7413 45.1583 30.7101ZM46.548 26.6959C44.6828 26.8765 43.4369 27.1972 43.4369 28.539C43.4369 29.4789 44.1741 29.877 45.28 29.877C45.7116 29.8859 46.1405 29.8069 46.5406 29.6448L46.548 26.6959Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70502 21.6827V22.678H11.3232V21.6827H9.70502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinextra);
export default __webpack_public_path__ + "static/media/finextra.36a9fb5ee0033b7598b4135f87a7e972.svg";
export { ForwardRef as ReactComponent };